import { render } from "./SelectStartingPlayers.vue?vue&type=template&id=7aba58a6&scoped=true"
import script from "./SelectStartingPlayers.vue?vue&type=script&lang=js"
export * from "./SelectStartingPlayers.vue?vue&type=script&lang=js"

import "./SelectStartingPlayers.vue?vue&type=style&index=0&id=7aba58a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aba58a6"]])

export default __exports__